import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { UpdateTeacherProfessionalInfoBody } from "@shared-kernel/application/ports/teacher/teacher-repository";

export const updateTeacherProfessionalInfo = createApiThunk<void, UpdateTeacherProfessionalInfoBody>(
  "teachers/updateTeacherProfessionalInfo",
  async (body, { extra: { teacherRepository } }) => {
    return teacherRepository!.updateProfessionalInfo(body);
  },
);

export const resetUpdateTeacherProfessionalInfo = createAction("teachers/resetUpdateTeacherProfessionalInfo");
